export default class SpritePool {
  constructor(type, length, scene) {
    this.pool = [];
    let i = length;
    while (--i > -1) {
      // eslint-disable-next-line new-cap
      this.pool[i] = new type(scene);
    }
  }

  getSprite () {
    if (this.pool.length > 0) {
      return this.pool.pop();
    }
    else {
      return null;
    }
  }

  returnSprite (sprite) {
    this.pool.push(sprite);
  }
}